import { render, staticRenderFns } from "./GradesRegistrationPage.vue?vue&type=template&id=3ad03a49"
import script from "./GradesRegistrationPage.vue?vue&type=script&lang=js"
export * from "./GradesRegistrationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports